import * as React from "react";
import type { SVGProps } from "react";

interface SetWinProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SetWin = ({ cancelled = false, ...props }: SetWinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M20.419 3.49c4.111 3.972 3.426 9.645-.589 13.524a9.35 9.35 0 0 1-3.457 2.12 2.05 2.05 0 0 1-1.613-.119l-.065-.036-.022.03a1.99 1.99 0 0 1-1.72.73l-.146-.016c-1.235-.177-2.175-.352-2.85-.536a5 5 0 0 0-.34-.081l-.073-.014-.148.154q-.172.18-.357.39l-.188.217c-.08.094-1.59 1.953-1.957 2.307-1.53 1.479-3.537 1.039-5.056-.43-1.542-1.49-2.014-3.565-.446-5.08.356-.345 2.26-1.789 2.38-1.885q.35-.281.635-.532l.118-.107-.022-.086-.03-.103-.035-.12c-.202-.664-.382-1.579-.554-2.775-.099-.694.137-1.292.546-1.71l.084-.083-.04-.072a2.05 2.05 0 0 1-.157-1.448l.05-.163a9.05 9.05 0 0 1 2.262-3.51c3.977-3.844 9.728-4.492 13.79-.566"
      />
      <path
        fill="#000"
        d="M19.898 4.03c3.773 3.645 3.146 8.836-.589 12.445a8.6 8.6 0 0 1-3.18 1.95 1.3 1.3 0 0 1-1.287-.256l-.329-.296-.116-.106v.033c-.06.648-.604 1.233-1.357 1.193l-.127-.013c-1.207-.173-2.12-.343-2.758-.517-.396-.108-.667-.147-.834-.133-.072.005-.083.01-.113.038-.288.279-.591.607-.926.997-.11.128-1.58 1.939-1.909 2.256-1.177 1.137-2.75.792-4.014-.43-1.276-1.232-1.642-2.846-.445-4.003.317-.307 2.173-1.714 2.327-1.838.407-.326.75-.622 1.039-.901.084-.082.09-.15-.124-.85-.19-.621-.363-1.502-.53-2.664-.108-.76.419-1.34 1.047-1.463l.018-.004-.066-.064-.232-.226a1.3 1.3 0 0 1-.32-1.363 8.3 8.3 0 0 1 1.824-2.964l.252-.254c3.71-3.587 9.008-4.184 12.749-.568"
      />
      <path
        fill="#EA4848"
        d="M6.3 8.247c2.723 2.653 8 7.705 9.404 8.949a7.3 7.3 0 0 0 2.701-1.655c2.86-2.764 4.085-7.2.59-10.577S10.91 2.77 8.052 5.532A7 7 0 0 0 6.3 8.247"
      />
      <path
        fill="#F9A66B"
        d="M10.497 17.21c-.997-.272-1.68-.272-2.192.224-1.175 1.135-2.248 2.684-2.835 3.252s-1.42.331-2.208-.43-1.014-1.583-.445-2.133c.57-.55 2.191-1.604 3.367-2.74.538-.521.538-1.107.215-2.164q-.25-.816-.485-2.468l7.183 6.942q-1.736-.248-2.6-.484"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SetWin;
